import * as React from 'react';
import Modal from 'components/common/modal';
import strings from 'utils/strings';
import { killEvent } from 'utils/domUtils';
import { replaceTokens } from '@ps/payscale-shared-ui/lib/StringUtils';
import './deleteUserModal.scss';

interface DeleteUserModalProps {
    onCommit?: () => void; // callback to notify parent of commit of dialog/value
    onHide?: () => void;   // callback to notify parent when modal hidden
    show: boolean;         // whether or not to make the modal visible
    userName: string;
}

// exported for testing
export interface DeleteUserModalState {
    visible: boolean;    // whether or not modal is currently visible
}

class DeleteUserModal extends React.PureComponent<DeleteUserModalProps, DeleteUserModalState> {
    constructor(props: DeleteUserModalProps) {
        super(props);
        this.state = Object.assign({}, this.state, {visible: props.show});

        // bind all our event handlers
        this._hide = this._hide.bind(this);
        this._onCommit = this._onCommit.bind(this);
    }

    // sync our internal state with props
    UNSAFE_componentWillReceiveProps(nextProps: DeleteUserModalProps): void {
        this.setState({
            visible: nextProps.show
        });
    }

    render(): React.ReactNode {
        const { visible } = this.state;
        const { userName } = this.props;
        return (
            <Modal className="delete-user-modal" show={visible} onHide={this._hide} >
                <h2 className="delete-user-modal__title">{strings.deleteUser}</h2>
                <div className="delete-user-modal__message">
                    {replaceTokens(strings.deleteUserConfirmMessage, userName)}
                </div>
                <div className="modal__button-container">
                    <a className="modal__cancel-link" href="#" onClick={this._hide}>{strings.cancel}</a>
                    <button
                        className="pxl-btn pxl-btn-primary modal__ok-button"
                        onClick={this._onCommit}
                    >
                        {strings.continue}
                    </button>
                </div>
            </Modal>
        );
    }

    private _hide(e?: React.SyntheticEvent<HTMLAnchorElement>): void {
        if (e) {
            killEvent(e);
        }

        this.setState({
            visible: false
        });

        const { onHide } = this.props;
        if (onHide) {
            onHide();
        }
    }

    private _onCommit(): void {
        const { onCommit } = this.props;
        if (onCommit) {
            onCommit();
        }
        this._hide();
    }
}

export { DeleteUserModal };
export default DeleteUserModal;


// WEBPACK FOOTER //
// ./src/components/deleteUserModal.tsx